import { startCase } from 'lodash'
import styled from 'styled-components'

import { List } from 'components/common/molecules/list'

const Wrapper = styled.div<IElement>`
  justify-content: center;
  width: 100%;
  color: #333333;
`
const CategoryTitle = styled.h4<IElement>`
  font-size: 18px;
  font-weight: 600;
  line-height: 24px;
  margin-bottom: 10px;
  margin-top: 20px;

  @media (max-width: 991px) {
    margin-top: 10px;
  }
`
const NoInformationText = styled.span<IElement>`
  font-weight: normal;
  font-size: 16px;
  line-height: 22px;
  color: #aaaaaa;
`

const Item = styled.li<IElement>`
  font-size: 16px;
  font-weight: 400;
  line-height: 22px;
  > span {
    position: relative;
    left: -15px;
  }
`

type UnitAmenitiesType = {
  wheelchairAccessible: boolean
  securitySystem: boolean
  furnished: boolean
  laundryHookUp: boolean
  privatePool: boolean
  microwave: boolean
  dishwasher: boolean
  washer: boolean
  dryer: boolean
  refrigerator: boolean
  garbageDisposal: boolean
  privateOutdoorSpace: boolean
  others: string[]
}

type HvacAmenitiesType = {
  central: boolean
  wallUnit: boolean
  windowUnit: boolean
  ceilingFan: boolean
  firePlace: boolean
  ductless: boolean
  baseBoard: boolean
  radiator: boolean
  others: string[]
}

type SharedAmenitiesType = {
  sharedOutdoorSpace: boolean
  wheelchairAccessible: boolean
  bikeParking: boolean
  pool: boolean
  fitnessCenter: boolean
  onSiteLaundry: boolean
  controlledAccess: boolean
  others: string[]
}

type PaidAmenitiesType = {
  gas: boolean
  electricity: boolean
  cable: boolean
  internet: boolean
  water: boolean
  heat: boolean
  trashService: boolean
  yardMaintenance: boolean
  others: string[]
}

type UtilitiesAndAmenitiesType = {
  unitAmenities: UnitAmenitiesType
  hvacAmenities: HvacAmenitiesType
  sharedAmenities: SharedAmenitiesType
  paidAmenities: PaidAmenitiesType
}

interface UtilitiesAndAmenitiesProps {
  utilitiesAndAmenities: UtilitiesAndAmenitiesType
}

export const UtilitiesAndAmenities = (props: UtilitiesAndAmenitiesProps) => {
  const { utilitiesAndAmenities } = props

  const unitAmenitiesList = Object.keys(utilitiesAndAmenities.unitAmenities).filter(
    (key) => utilitiesAndAmenities.unitAmenities[key] && key !== 'others',
  )
  utilitiesAndAmenities.unitAmenities.others?.forEach((item) => unitAmenitiesList.push(item))

  const hvacAmenitiesList = Object.keys(utilitiesAndAmenities.hvacAmenities).filter(
    (key) => utilitiesAndAmenities.hvacAmenities[key] && key !== 'others',
  )
  utilitiesAndAmenities.hvacAmenities.others?.forEach((item) => hvacAmenitiesList.push(item))

  const sharedAmenitiesList = Object.keys(utilitiesAndAmenities.sharedAmenities).filter(
    (key) => utilitiesAndAmenities.sharedAmenities[key] && key !== 'others',
  )
  utilitiesAndAmenities.sharedAmenities.others?.forEach((item) => sharedAmenitiesList.push(item))

  const paidAmenitiesList = Object.keys(utilitiesAndAmenities.paidAmenities).filter(
    (key) => utilitiesAndAmenities.paidAmenities[key] && key !== 'others',
  )
  utilitiesAndAmenities.paidAmenities.others?.forEach((item) => paidAmenitiesList.push(item))

  const renderList = (list: string[], title: string) => (
    <>
      <CategoryTitle>{title}</CategoryTitle>
      {list.length ? (
        <ul className="row">
          <List
            dataSource={list}
            renderItem={(item) => (
              <Item className="col-12 col-lg-6">
                <span>{startCase(item)}</span>
              </Item>
            )}
          />
        </ul>
      ) : (
        <NoInformationText>This information is not provided</NoInformationText>
      )}
    </>
  )

  return (
    <>
      <Wrapper id="UtilitiesAndAmenitiesContainer">
        {renderList(paidAmenitiesList, 'Rent Includes')}
        {renderList(hvacAmenitiesList, 'Heating & Cooling')}
        {renderList(unitAmenitiesList, 'Unit Amenities')}
        {renderList(sharedAmenitiesList, 'Shared Amenities')}
      </Wrapper>
    </>
  )
}
